export default __webpack_public_path__ + "static/media/navigation-breakdown.408adb7e.png";